import {UseFormReturn} from "react-hook-form";
import {Grid, Typography} from "@mui/material";
import {Frame} from "../base/Frame";
import {LabeledInput} from "../base/LabeledInput";
import {COUNTRY_OPTIONS} from "../../utils/countriesUtils";
import {TextInput} from "../base/TextInput";
import {AutocompleteInput} from "../base/AutocompleteInput";
import {useTranslation} from "react-i18next";

export interface UserInfoFormInputs {
    firstName: string;
    lastName: string;
    email: string;
    company: string;
    country: string | null;
    phone: string;
}

export interface Props {
    initFormValues: UserInfoFormInputs;
    form: UseFormReturn<UserInfoFormInputs>;
    disabled?: boolean;
}

export const UserInfoForm: React.FC<Props> = ({
    initFormValues,
    form: {
        register,
        control,
        formState: {errors},
    },
    disabled,
}) => {
    const {t} = useTranslation();
    return (
        <Frame>
            <Typography fontSize={16} textTransform="uppercase" sx={{mb: "1rem"}}>
                {t("users.info_form.title")}
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <LabeledInput label={t("users.info_form.firstname")}>
                        <TextInput
                            name="firstName"
                            type="text"
                            register={register}
                            errors={errors}
                            disabled={disabled}
                            inputProps={{autoComplete: "given-name"}}
                        />
                    </LabeledInput>
                </Grid>
                <Grid item xs={6}>
                    <LabeledInput label={t("users.info_form.lastname")}>
                        <TextInput
                            name="lastName"
                            type="text"
                            register={register}
                            errors={errors}
                            disabled={disabled}
                            inputProps={{autoComplete: "family-name"}}
                        />
                    </LabeledInput>
                </Grid>
                <Grid item xs={6}>
                    <LabeledInput label={t("users.info_form.email")}>
                        <TextInput
                            name="email"
                            type="text"
                            register={register}
                            errors={errors}
                            disabled={disabled}
                            inputProps={{autoComplete: "email"}}
                        />
                    </LabeledInput>
                </Grid>
                <Grid item xs={6}>
                    <LabeledInput label={t("users.info_form.company")}>
                        <TextInput
                            name="company"
                            type="text"
                            register={register}
                            errors={errors}
                            disabled={disabled}
                            inputProps={{autoComplete: "organization"}}
                        />
                    </LabeledInput>
                </Grid>
                <Grid item xs={6}>
                    <LabeledInput label={t("users.info_form.country")}>
                        <AutocompleteInput
                            name="country"
                            control={control}
                            options={COUNTRY_OPTIONS}
                            disableClear
                            initialValue={initFormValues.country}
                            getOptionLabel={(option) => option.label}
                            disabled={disabled}
                        />
                    </LabeledInput>
                </Grid>
                <Grid item xs={6}>
                    <LabeledInput label={t("users.info_form.phone")}>
                        <TextInput
                            name="phone"
                            type="text"
                            register={register}
                            errors={errors}
                            disabled={disabled}
                            inputProps={{autoComplete: "tel"}}
                        />
                    </LabeledInput>
                </Grid>
            </Grid>
        </Frame>
    );
};
